
import { Moment } from 'moment';
import { EmailContact } from './email-contact.model';
import { PhoneContact } from './phone-contact.model';
import { Address } from './address.model';
import { PetitionFeesInfo } from './petitionFeesInfo.model';

export class Company {
  constructor(obj: Partial<Company>) {
    Object.assign(this, obj);
  }
  
  isWorkforceNotified?:number;
  id?: number;
  title?: string;
  description?: string;
  // companyLogo?: Blob;
  companyLogo?: string;
  logoFile?: string;
  companyName?: string;
  companyCode?: string;
  feiNo?: string;
  domainName?:String;
  phoneNo?: number;
  establishedDate?: string;
  establishedYear?: string;
  incorporationLoc?: {
    countryCode?: string;
  };
  signatoryList?: Signatory[];
  companyType?: {};
  emailContacts: [];
  emailContact?: EmailContact;
  altEmailContact?: EmailContact;
  phoneContact?: PhoneContact;
  mobileContact?: PhoneContact;
  faxContact?: PhoneContact;
  phoneContacts?: [];
  address?: Address[];
  employeeCount?: number;
  grossAnnualIncome?: string;
  noOfUsers?: number;
  classification?: string;
  netAnnualIncome?: string;
  mgrExecUSCount?: string;
  mgrExecNonUSCount?: string;
  dotCode?: string;
  naicsCode?: string;
  naicsCodeNew?: any[];
  naicsCodeSelectedTitleArr?: string[];
  addressLine1?: string;
  otherBusinessName?: string;
  othername?: string;
  businessType?: any[];
  petitionFeesInfo: PetitionFeesInfo[];
  isTotalEmployeeMoreThanTwentyFive?: boolean;
  isNonProfitTaxExemptOrg?:boolean;
  taxIdenNum?:string;
  taxIdentificationType?:{
    code?:string;
  }

}

export class petionerCompany {
  constructor(obj: Partial<petionerCompany>) {
    Object.assign(this, obj);
  }
  pageNumber?: number;
  pageSize?: number;
  searchText?: string;
}


export class i9Company {
  constructor(obj: Partial<i9Company>) {
    Object.assign(this, obj);
  }
  id?: number;
  title?: string;
  description?: string; 
  companyLogo?: string;
  logoFile?: string;
  companyName?: string;
  companyCode?: string;
  feiNo?: string;
  domainName?:String;
  phoneNo?: number;
  establishedDate?: string;
  establishedYear?: string;
  incorporationLoc?: {
    countryCode?: string;
  };
  companyType?: {};
  emailContacts: [];
  emailContact?: EmailContact;
  altEmailContact?: EmailContact;
  phoneContact?: PhoneContact;
  mobileContact?: PhoneContact;
  faxContact?: PhoneContact;
  phoneContacts?: [];
  address?: Address[];
  employeeCount?: number;
  grossAnnualIncome?: string;
  classification?: string;
  netAnnualIncome?: string;
  mgrExecUSCount?: string;
  mgrExecNonUSCount?: string;
  dotCode?: string;
  naicsCode?: string;
  naicsCodeNew?: any[];
  naicsCodeSelectedTitleArr?: string[];
  addressLine1?: string;
  otherBusinessName?: string;
  othername?: string;
  businessType?: any[];
  petitionFeesInfo: PetitionFeesInfo[];

  locality?:string;
  locality1?:string;
  fname?:string;
  lname?:string;
  middlename?:string;
  companyEmail?:string;
}

export class Signatory {
  id: number | null;
  firstName: string;
  lastName: string;
  designation: string;
  countryCode: string;
  phone: string;
  email: string;  
  
  constructor(init?: Partial<Signatory>) {
    Object.assign(this, init);
  }
}
